module.exports = {"cash-sale":"Cash sale","invoice-template":"Invoice Template","processing-fee":"Processing Fee","vouchers-for-invoice":"Vouchers for invoice","address":"Address","payment-type":"Payment Type","do-cash-sale":"Do Cash Sale","positions":{"_":"Position","new":"New position","price":"Unit price","amount":"Amount","total":"Total"},"contacts":{"_":"Contact","select":"Please select a contact","change":"Change contact"},"address-type":{"_":"Address type","preferred":"Preferred","private":"Private","business":"Business","custom":"Custom"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/pos.json
// module id = 2403
// module chunks = 1